// Mobile top bar. Two modes:
//   - list:   [ search input | + new | ⋯ menu ]
//   - detail: [ ← back | title | ✎ edit | ⋯ menu ]
// Hidden on desktop via CSS (display: none above 768px).

import { el, clear } from './dom.js';
import { icon } from './icons.js';

export function renderTopbar(root, opts) {
  clear(root);
  root.classList.add('topbar');
  root.classList.toggle('topbar-detail', opts.mode === 'detail');

  if (opts.mode === 'detail') {
    root.append(renderDetailMode(opts));
  } else {
    root.append(renderListMode(opts));
  }
}

function renderListMode({ search, onSearchChange, onNew, onMenu, syncStatus }) {
  const input = el('input', {
    type: 'search',
    placeholder: 'Search',
    value: search ?? '',
    autocomplete: 'off',
    autocorrect: 'off',
    autocapitalize: 'off',
    spellcheck: false,
    oninput: (e) => onSearchChange?.(e.target.value),
  });

  const newBtn = el('button', {
    class: 'topbar-new',
    'aria-label': 'New entry',
    onclick: () => onNew?.(),
  }, ['+']);

  const menuBtn = el('button', {
    class: `topbar-menu ${syncStatusClass(syncStatus)}`.trim(),
    'aria-label': 'More actions',
    onclick: (e) => onMenu?.(e.currentTarget),
  }, ['⋯']);

  return el('div', { class: 'topbar-row' }, [input, newBtn, menuBtn]);
}

function renderDetailMode({ title, starred, onBack, onEdit, onToggleStar, onMenu, syncStatus }) {
  const backBtn = el('button', {
    class: 'topbar-back',
    'aria-label': 'Back',
    onclick: () => onBack?.(),
  }, ['←']);

  const titleEl = el('div', { class: 'topbar-title' }, [title ?? '']);

  const starBtn = el('button', {
    class: 'topbar-star' + (starred ? ' starred' : ''),
    'aria-label': starred ? 'Unstar' : 'Star',
    'aria-pressed': starred ? 'true' : 'false',
    onclick: () => onToggleStar?.(),
  }, [icon(starred ? 'star' : 'star_outline', { size: 22 })]);

  const editBtn = el('button', {
    class: 'topbar-edit',
    'aria-label': 'Edit',
    onclick: () => onEdit?.(),
  }, ['✎']);

  const menuBtn = el('button', {
    class: `topbar-menu ${syncStatusClass(syncStatus)}`.trim(),
    'aria-label': 'More actions',
    onclick: (e) => onMenu?.(e.currentTarget),
  }, ['⋯']);

  return el('div', { class: 'topbar-row' }, [backBtn, titleEl, starBtn, editBtn, menuBtn]);
}

function syncStatusClass(status) {
  if (status === 'syncing') return 'status-syncing';
  if (status === 'conflict') return 'status-conflict';
  if (status === 'error') return 'status-error';
  return '';
}
